<template name="数据报表和光伏分析页共用">
  <div class="search-row">
    <el-row class="search-el-row" :gutter="12">
      <div class="tabs-wrap" :span="dataTypes.length > 3 ? 8 : 4" v-if="showTimeType && page!=='photovoltaicStation'">
        <compTab @change="handleDataTypeChange" :options="dataTypes"></compTab>
      </div>
      <!-- <el-col :span="4">
         <el-select v-model="dataType" @change="handleDataTypeChange">
          <el-option
            v-for="item in dataTypes"
            :key="item.id"
            :label="item.i18nValue"
            :value="item.dictKey">
          </el-option>
         </el-select>
      </el-col> -->

      <div :span="['photovoltaicStation', 'photovoltaicInverter'].includes(page)  ? 11 : 8">
        
        <div style="display: flex; align-items: center;" >
          <div class="divider" v-if="showTimeType && page!=='photovoltaicStation'"></div>
          <!-- <div class="timelabel">{{ Lang.label.selectDate }}</div> -->
          <template v-if="['photovoltaicStation', 'photovoltaicInverter'].includes(page)">
            <!-- 日选月份的 月份选年 -->
            <el-date-picker
              :style="dateStyle"
              v-if="dataType < 6"
              :clearable="false"
              v-model="datetime"
              type="date"
              value-format="YYYY-MM-DD"
              format="YYYY-MM-DD"
              @change="handleChange"
              :disabled-date="pickerOptions.disabledDate"
            />
            <el-date-picker
              :style="dateStyle"
              v-if="dataType == 6"
              :clearable="false"
              v-model="datetime"
              type="month"
              value-format="YYYY-MM"
              format="YYYY-MM"
              @change="handleChange"
              :disabled-date="pickerOptions.disabledDate"
            />
            <el-date-picker
              :style="dateStyle"
              v-if="dataType == 7"
              :clearable="false"
              v-model="datetime"
              type="year"
              value-format="YYYY"
              format="YYYY"
              @change="handleChange"
              :disabled-date="pickerOptions.disabledDate"
            />
          </template>
          <template v-else>
            <el-date-picker
              :style="dateStyle"
              v-if="dataType < 6"
              :clearable="false"
              size="default"
              v-model="datetime"
              type="date"
              value-format="YYYY-MM-DD"
              format="YYYY-MM-DD"
              @change="handleChange"
              :disabled-date="pickerOptions.disabledDate"
              :placeholder="Lang.label.selectDate">
            </el-date-picker>
            <el-date-picker
              :style="dateStyle"
              v-if="dataType == 6"
              :clearable="false"
              v-model="daterange"
              type="daterange"
              value-format="YYYY-MM-DD"
              format="YYYY-MM-DD"
              :default-value="new Date()"
              :default-time="new Date()"
              @change="handleChange"
              :disabled-date="pickerOptions.disabledDate"
            />
            <el-date-picker
              :style="dateStyle"
              v-if="dataType == 7"
              :clearable="false"
              v-model="daterange"
              type="monthrange"
              value-format="YYYY-MM"
              format="YYYY-MM"
              @change="handleChange"
              :disabled-date="pickerOptions.disabledDate"
            />
            <el-date-picker
              :style="dateStyle"
              v-if="dataType == 8"
              :clearable="false"
              v-model="daterange"
              type="yearrange"
              value-format="YYYY"
              format="YYYY"
              @change="handleChange"
              :disabled-date="pickerOptions.disabledDate"
            />
          </template>
        </div>
      </div>
      <div class="tabs-wrap" :span="dataTypes.length > 3 ? 8 : 4" v-if="showTimeType && page==='photovoltaicStation'">
        <div class="divider" v-if="showTimeType && page==='photovoltaicStation'"></div>
        <compTab @change="handleDataTypeChange" :options="dataTypes"></compTab>
      </div>
      <el-col :span="4" v-if="showCompareType">
        <el-select v-model="compareType" @change="handleChange">
          <el-option
            v-for="item in compareTypes"
            :key="item.id"
            :label="item.i18nValue"
            :value="item.dictKey">
          </el-option>
        </el-select>
      </el-col>
      <el-col :span="2" v-if="showSearchButton">
        <comp-button icon="icon-Search" type="default" @click="handleChange(true)">
          {{ Lang.btn.search }}
        </comp-button>
      </el-col>
    </el-row>
  </div>
</template>
<script setup>
  import { ref, onMounted, withDefaults } from "vue";
  import compTab from '@/components/comp-tab/index.vue';
  // import { dataTimeTypes } from '@/const/options';
  import dayjs from 'dayjs';
  import { getDictionary } from '@/api/system/dict';
  import { Lang } from "@/lang/lang";

  const props = defineProps(['isAnalysis', 'JFPG', 'showCompareType', 'showSearchButton', 'page', 'showTimeType', 'dateStyle'])

  // const props = withDefaults(defineProps(), {
  //   isAnalysis: false,
  //   JFPG: false,
  //   showCompareType: true,
  //   showSearchButton: true,
  //   page: '',
  // })

  const compareTypes = ref([]);
  const dataTypes = ref([]);

  const now = dayjs()
  const current = dayjs(new Date()).format('YYYY-MM-DD HH:mm:ss');
  const oneDayBefore = now.subtract(1, 'day').format('YYYY-MM-DD HH:mm:ss');
  const daterange = ref([current, current]);
  const datetime = ref(current);
  const dataType = ref(['photovoltaicStation', 'photovoltaicInverter'].includes(props.page) ? '5' : '3'); // 1分钟 2:5分钟 3:15分钟 4:30分钟 5:小时 6:日 7:月 8:年
  const compareType = ref('0'); // 0 否 
  const emit = defineEmits(['change'])
  // const filterDataTypes = dataTimeTypes.filter(item => item.show);
  // const dataTypes = ref(filterDataTypes);
  const pickerOptions = ref({
    disabledDate: (time) => {
      const now = new Date().getTime();
      const times = new Date(time).getTime();
      // 不可选择超过今天的日期
      if (times > now) {
        return true
      }
      return false
    }
  })
  

  const getTime = () => {
    const values = daterange.value;
    let stime = null;
    let etime = null;

    if (values) {
      stime = values[0];
      etime = values[1];
      if (['photovoltaicStation', 'photovoltaicInverter'].includes(props.page)) {
        stime = datetime.value;
      } else {
        stime = dayjs(stime).format("YYYY-MM-DD HH:mm:ss")
        etime = dayjs(etime).format("YYYY-MM-DD HH:mm:ss")
      }
      if (new Date(stime).getTime() > new Date().getTime()) {
        stime = dayjs(new Date().getTime()).format("YYYY-MM-DD HH:mm:ss")
      }
      if (stime) {
        stime = dayjs(stime).startOf('day').format('YYYY-MM-DD HH:mm:ss')
        if (['photovoltaicStation', 'photovoltaicInverter'].includes(props.page)) {
          // 没有范围，从stime判断
          if (dataType.value == 5) { // 小时
            etime = dayjs(stime).endOf('day').format('YYYY-MM-DD HH:mm:ss')
          }
          if (dataType.value == 6) { // 日报
            etime = dayjs(stime).endOf('day').format('YYYY-MM-DD HH:mm:ss')
          }
          if (dataType.value == 7) { // 月报
            etime = dayjs(stime).endOf('month').format('YYYY-MM-DD HH:mm:ss')
          }
          if (dataType.value == 8) { // 年报
            etime = dayjs(stime).endOf('year').format('YYYY-MM-DD HH:mm:ss')
          }
        } else {
          if (dataType.value == 5) { // 小时
            stime = dayjs(stime).startOf('day').format('YYYY-MM-DD HH:mm:ss')
            etime = dayjs(etime).endOf('day').format('YYYY-MM-DD HH:mm:ss')
          }
          if (dataType.value == 6) { // 日报
            stime = dayjs(stime).startOf('day').format('YYYY-MM-DD HH:mm:ss')
            etime = dayjs(etime).endOf('day').format('YYYY-MM-DD HH:mm:ss')
          }
          if (dataType.value == 7) { // 月报
            stime = dayjs(stime).startOf('month').format('YYYY-MM-DD HH:mm:ss')
            etime = dayjs(etime).endOf('day').format('YYYY-MM-DD HH:mm:ss')
          }
          if (dataType.value == 8) { // 年报
            stime = dayjs(stime).startOf('year').format('YYYY-MM-DD HH:mm:ss')
            etime = dayjs(etime).endOf('day').format('YYYY-MM-DD HH:mm:ss')
          }
        }
      }
      return {
        stime,
        etime
      }
    }
  }
  function handleDataTypeChange(i, item) {
    dataType.value = item.dictKey;
    // 类型变换重置时间选择器初始化值
    resetDefaultValue()
    handleChange(true)
  }

  function roundToNearestQuarterHour(dateTimeStr) { // 取整%15分钟类型
    const date = new Date(dateTimeStr);

    const minutes = date.getMinutes();
    const roundedMinutes = Math.floor(minutes / 15) * 15;

    date.setMinutes(roundedMinutes);
    date.setSeconds(0);
    date.setMilliseconds(0);

    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    const hours = String(date.getHours()).padStart(2, '0');
    const mins = String(date.getMinutes()).padStart(2, '0');
    
    return `${year}-${month}-${day} ${hours}:${mins}:00`;
}
  function getCurrentHourStart() {
      const now = new Date();

      now.setMinutes(0);
      now.setSeconds(0);
      now.setMilliseconds(0);

      const year = now.getFullYear();
      const month = String(now.getMonth() + 1).padStart(2, '0');
      const day = String(now.getDate()).padStart(2, '0');
      const hours = String(now.getHours()).padStart(2, '0');

      return `${year}-${month}-${day} ${hours}:00:00`;
  }

  function resetDefaultValue(search) {
    const now = dayjs()
    const roundCurrent = roundToNearestQuarterHour(current);
    const roundHour =  getCurrentHourStart(current);
    const dayBegin = now.startOf('day').format('YYYY-MM-DD HH:mm:ss');
    datetime.value = dayjs(new Date()).format('YYYY-MM-DD HH:mm:ss');
    const foreYearBefore = now.subtract(4, 'year').format('YYYY-MM-DD HH:mm:ss');
    daterange.value = [dayBegin, roundCurrent]
    if (props.page === 'photovoltaicInverter') {
      // 
    } else {
      if (dataType.value == 3) { // 15分钟
        daterange.value = [dayjs(current).startOf('day'), roundCurrent] // 默认今天0点到当前时间的近一次00、15、30、或45分钟
      } else  if (dataType.value == 5) { // 小时
        daterange.value = [dayjs(current).startOf('day'), roundHour] // 默认今天0点到当前时间整点
      } else  if (dataType.value == 6) { // 日
        daterange.value = [dayjs(current).startOf('month'), current] // 默认本月1号至今天
      } else if (dataType.value == 7) {  // 月
        daterange.value = [dayjs(current).startOf('year'), current] // 默认本年1月到当前月
      } else if (dataType.value == 8) { // 年
        daterange.value = [foreYearBefore, current] // 跨时间段年报显示前4年和当前年
      }
    }
    if (search) {
      handleChange()
    }
  }
  function handleChange(flag) {
    if (flag !== true && props.showSearchButton) {
      return
    }
    const times = getTime()
    emit('change', {
      dataType: dataType.value,
      compareType: compareType.value,
      ...times,
    })
  }

  function getParams() {
    const times = getTime()
    return {
      dataType: dataType.value,
      compareType: compareType.value,
      ...times,
    }
  }

  function getCompareTypes() {
    getDictionary({code: 'compareType'}).then(res => {
      if (res.data.code === 200) {
        const data = res.data.data || []
        if (props.isAnalysis) {
          compareTypes.value = data.filter(item => item.dictKey != 3)
        } else {
          compareTypes.value = data;
        }
        compareType.value = compareTypes.value[0].dictKey;
      }
    })
  }

  function getJFPGTypes() {
    getDictionary({code: 'jfpg'}).then(res => {
      if (res.data.code === 200) {
        const data = res.data.data || []
        compareTypes.value = data;
        compareType.value = ''
      }
    })
  }

  onMounted(() => {
    if (props.JFPG) {
      getJFPGTypes();
    } else {
      getCompareTypes();
    }
    getDictionary({code: 'dataType'}).then(res => {
      const data = res.data.data;
      if (res.data.code === 200) {
        if (props.JFPG) {
          dataTypes.value = data.filter(item => {
            return ['5','6','7'].includes(item.dictKey)
          })
        } else {
          // 日期选择订制
          if (['photovoltaicStation', 'photovoltaicInverter'].includes(props.page)) {
            const list = data.filter(item => {
              return ['5','6','7'].includes(item.dictKey)
            })
            dataTypes.value = list;
          } else {
            dataTypes.value = data;
          }
        }
        dataType.value = dataTypes.value[0].dictKey;
      }
    })
    if (daterange.value) {
      handleChange();
    }
  })

  defineExpose({
    getParams,
  })
</script>
<style lang="scss" scoped>

</style>